import React, { useEffect, useMemo, useState } from 'react';
import { Select, Checkbox } from 'antd';
import SelectIconWrapperAntd from '../../../../Components/SelectIconWrapperAntd';
import buildingIcon from '../../../../Assets/Icons/ExitInterview/corporate_fare.svg';
import { Tooltip } from '@mui/material';

/**
 * Props:
 * - setFilters: (updater) => void
 * - value: string[] (selected department ids)
 * - options: Array<{ _id: string, name: string }>  // department list from API
 * - style?: CSSProperties
 */
export function DepartmentFilter({
	setFilters,
	value = [],
	options = [], // default options
	style = { width: 260 },
}) {
	const [pending, setPending] = useState(value); // local pending selection state

	// keep in sync if external value changes
	useEffect(() => {
		setPending(value || []);
	}, [value]);

	const selectOptions = useMemo(
		() =>
			options.map((o) => ({
				value: o,
				label: (
					<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						{/* <Checkbox
              checked={pending.includes(o._id)}
              onClick={(e) => {
                e.stopPropagation(); // prevent double toggling
                const exists = pending.includes(o._id);
                const next = exists ? pending.filter((id) => id !== o._id) : [...pending, o._id];
                setPending(next);
              }}
            /> */}
						{o}
					</span>
				),
				searchText: o?.toLowerCase(),
			})),
		[options, pending],
	);

	const handleChange = (ids) => {
		setPending(ids);
		if (JSON.stringify(ids) === JSON.stringify(value)) return; // no change
		setFilters?.((prev) => ({
			...prev,
			departments: ids,
		}));
	};

	const applyPending = () => {
		console.log('applying pending departments');
		if (JSON.stringify(pending) === JSON.stringify(value)) return; // no change
		setFilters?.((prev) => ({
			...prev,
			departments: pending,
		}));
	};

	return (
		<SelectIconWrapperAntd startIcon={<img src={buildingIcon} alt="Dept" style={{ width: 16, height: 16 }} />}>
			<Select
				mode="multiple"
				value={pending}
				onChange={handleChange}
				// onDropdownVisibleChange={(open) => !open && applyPending()}
				// onBlur={applyPending}
				options={selectOptions}
				style={style}
				placeholder="Departments: All"
				showSearch
				optionFilterProp="searchText"
				// We render our own checkbox; hide default selected icon
				optionRender={(option, { index }) => {
					const id = option.value;
					const selected = pending.includes(id);
					return (
						<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<span style={{ pointerEvents: 'none', display: 'inline-flex', alignItems: 'center' }}>
								<Checkbox checked={selected} style={{ width: 16, height: 16, transform: 'scale(0.9)' }} />
							</span>
							<span>{option.label}</span>
						</span>
					);
				}}
				menuItemSelectedIcon={null}
				maxTagCount="responsive"
				allowClear
				onClear={() => {
					setPending([]);
					// optionally apply immediately:
					// setFilters?.((prev) => ({ ...prev, departments: [] }));
				}}
				maxTagPlaceholder={(omittedValues) => (
					<Tooltip title={omittedValues.map((v) => v.label.props.children).join(', ')} placement="bottom">
						<span style={{ cursor: 'pointer' }}>{`${omittedValues.length}+`}</span>
					</Tooltip>
				)}
			/>
		</SelectIconWrapperAntd>
	);
}

export function CampaignFilter({
	setFilters,
	value = [],
	options = [], // default options
	style = { width: 260 },
}) {
	const [pending, setPending] = useState(value); // local pending selection state

	// keep in sync if external value changes
	useEffect(() => {
		setPending(value || []);
	}, [value]);

	const selectOptions = useMemo(
		() =>
			options.map((o) => ({
				value: o._id,
				label: (
					<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						{/* <Checkbox
              checked={pending.includes(o._id)}
              onClick={(e) => {
                e.stopPropagation(); // prevent double toggling
                const exists = pending.includes(o._id);
                const next = exists ? pending.filter((id) => id !== o._id) : [...pending, o._id];
                setPending(next);
              }}
            /> */}
						{o?.basicDetails?.name}
					</span>
				),
				searchText: o?.basicDetails?.name?.toLowerCase(),
			})),
		[options, pending],
	);

	const handleChange = (ids) => {
		setPending(ids);
		// applyPending();
		if (JSON.stringify(ids) === JSON.stringify(value)) return; // no change
		setFilters?.((prev) => ({
			...prev,
			campaignIds: ids,
		}));
	};

	const applyPending = () => {
		console.log('applying pending departments');
		if (JSON.stringify(pending) === JSON.stringify(value)) return; // no change
		setFilters?.((prev) => ({
			...prev,
			campaignIds: pending,
		}));
	};

	return (
		<SelectIconWrapperAntd startIcon={<img src={buildingIcon} alt="Dept" style={{ width: 16, height: 16 }} />}>
			<Select
				mode="multiple"
				value={pending}
				onChange={handleChange}
				// onDropdownVisibleChange={(open) => !open && applyPending()}
				// onBlur={applyPending}
				options={selectOptions}
				style={style}
				placeholder="Campaigns: All"
				showSearch
				optionFilterProp="searchText"
				// We render our own checkbox; hide default selected icon
				optionRender={(option, { index }) => {
					const id = option.value;
					const selected = pending.includes(id);
					return (
						<span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<span style={{ pointerEvents: 'none', display: 'inline-flex', alignItems: 'center' }}>
								<Checkbox checked={selected} style={{ width: 16, height: 16, transform: 'scale(0.9)' }} />
							</span>
							<span>{option.label}</span>
						</span>
					);
				}}
				menuItemSelectedIcon={null}
				maxTagCount="responsive"
				allowClear
				onClear={() => {
					setPending([]);
					// optionally apply immediately:
					// setFilters?.((prev) => ({ ...prev, departments: [] }));
				}}
				maxTagPlaceholder={(omittedValues) => (
					<Tooltip title={omittedValues.map((v) => v.label.props.children).join(', ')} placement="bottom">
						<span style={{ cursor: 'pointer' }}>{`${omittedValues.length}+`}</span>
					</Tooltip>
				)}
			/>
		</SelectIconWrapperAntd>
	);
}

// UPDATESEVEN -> Will Combine Both Filters in Single File TO MAKE CODE MORE CLEAN
